import { Badge, Card, Col, Container, Row } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import ProfilePicture from "ProfilePictures/ValentinGalfre.jpg";
import Project1 from "./images/Project1.jpg";
import Project2 from "./images/Project2.jpg";
import Project3 from "./images/Project3.jpg";
import Project4 from "./images/Project4.jpg";
import Style from "./styles.module.scss";

interface IProject {
  title: string;
  desc: string;
  img: string;
  link: string;
}

interface IBadge {
  variant: string;
  text: string;
}

const projects: IProject[] = [
  {
    title: "Crombie Webpage UI Clone",
    desc: "Crombie Mobile Webpage UI Clone. Made with NextJS & TailwindCSS + Framer Motion 🌈",
    img: Project1,
    link: "https://galfrevn2.netlify.app/project/crombie"
  },
  {
    title: "Mercado Libre Webpage UI Clone",
    desc: "MercadoLibre Responsive Home & Product description Webpage Clone. Made with NextJS & TailwindCSS 👜",
    img: Project2,
    link: "https://galfrevn2.netlify.app/project/mercadolibre"
  },
  {
    title: "Fullstack MERN Ecommerce",
    desc: "Magasin is a Fullstack Ecommerce, made for a school project with Vanilla JavaScript, NodeJS, Express & MongoDB 👚",
    img: Project3,
    link: "https://galfrevn2.netlify.app/project/magasin"
  },
  {
    title: "Responsive Google Search Clone",
    desc: "VNSearch is a Google Search Clone made with ReactJS, Tailwind CSS and a RapidAPI Google Search Clone 🔎",
    img: Project4,
    link: "https://galfrevn2.netlify.app/project/google"
  }
];

const badges: IBadge[] = [
  {
    variant: "danger",
    text: "HTML"
  },
  {
    variant: "primary",
    text: "CSS"
  },
  {
    variant: "warning",
    text: "JavaScript"
  },
  {
    variant: "info",
    text: "Bootstrap"
  },
  {
    variant: "light",
    text: "TailwindCSS"
  },
  {
    variant: "primary",
    text: "ReactJS"
  },
  {
    variant: "success",
    text: "Figma"
  }
];

const ValentinGalfre: React.FC<RouteProps> = () => {
  return (
    <Container className={Style.my40}>
      <div className='d-flex flex-row align-items-center mb-4'>
        <a
          href='https://galfrevn2.netlify.app'
          target='_blank'
          id='logo'
          rel='noreferrer'>
          <img
            className='rounded-circle mr-3 '
            width={92}
            alt='Valentin Galfre Portfolio'
            height={92}
            src={ProfilePicture}
          />
        </a>

        <div>
          <h1 className='font-weight-bold' id='name'>
            Valentin Galfré
          </h1>
          <p className='text-muted font-weight-normal'>Frontend developer </p>
        </div>
      </div>
      <p className='mt-4'>
        Hola, soy <b> Valentín Galfré</b>, Front-end Developer Trainee.
      </p>
      <p className='mt-1'>
        Tengo 19 años y vivo de Santo Tomé. Soy estudiante de ingenieria en
        informática en la FICH UNL. Me encanta la programacion y el diseño.
        <br />
        Estoy estudiando React por mi cuenta.
      </p>
      <p>Me gusta la musica de los 80s 🎸</p>
      <p>
        Tengo <b> buenos conocimientos</b> en las siguintes tecnologias:
      </p>
      <div>
        {badges.map(badge => (
          <Badge
            pill
            className='mr-2 px-3 py-2'
            data-testid={"Conocimientos"}
            variant={badge.variant}>
            {badge.text}
          </Badge>
        ))}
      </div>

      <p className='mt-5'>Algunos de mis proyectos personales:</p>

      <Row>
        {projects.map((project: IProject, index) => (
          <Col xs={12} md={6} lg={4} key={index} className='py-3'>
            <Card className='w-100'>
              <Card.Img variant='top' alt='Project' src={project.img} />
              <Card.Body>
                <Card.Title className={`${Style.text16} font-weight-bold `}>
                  {project.title}{" "}
                </Card.Title>
                <Card.Text>{project.desc}</Card.Text>
                <a href={project.link} target='_blank' rel='noreferrer'>
                  Visitar
                </a>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <div className='mt-5'>
        <div className='d-flex'></div>
      </div>
    </Container>
  );
};

export default new Content({
  Component: ValentinGalfre,
  title: "Valentin Galfre",
  route: "valentin-galfre",
  tags: [
    "frontend",
    "trainee",
    "valentin",
    "galfre",
    "react",
    "bootstrap",
    "javascript",
    "css",
    "html"
  ]
});
